// extracted by mini-css-extract-plugin
module.exports = {"styledAccordion":"lKPfFo4r"};